import EvidationLogo from "./EvidationLogo";

export default EvidationLogo;
